export default __webpack_public_path__ + "static/media/tripadvisor_icon2.b0c222c7.svg";